import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./GstApiDueNotice.css";

const GST_API_LIFETIME_NOTICE_KEY = "gst-api-lifetime-activated-notice-seen";
const ACTIVATION_MESSAGE = "Your GST API key is activated for lifetime.";

const hasSeenLifetimeNotice = () => {
  if (typeof window === "undefined") return true;
  return window.localStorage.getItem(GST_API_LIFETIME_NOTICE_KEY) === "1";
};

const markLifetimeNoticeSeen = () => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(GST_API_LIFETIME_NOTICE_KEY, "1");
};

const GstApiDueNotice = () => {
  const [showPopup, setShowPopup] = useState(() => !hasSeenLifetimeNotice());

  const closeNotice = () => {
    markLifetimeNoticeSeen();
    setShowPopup(false);
  };

  return (
    <Modal
      show={showPopup}
      onHide={closeNotice}
      centered
      className="gst-api-due-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>GST API Activation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="gst-api-due-popup">
          <span className="material-symbols-outlined">verified</span>
          <div>
            <h5>{ACTIVATION_MESSAGE}</h5>
            <p>This message will not appear again after you acknowledge it.</p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={closeNotice}>
          Acknowledge
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GstApiDueNotice;
